// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentDocsTransport_root__3MlDt","upload":"ContentDocsTransport_upload__3WqfS","btn":"ContentDocsTransport_btn__nzgd5"};